import config from "config/config";
import type { LanguageCode } from "config/languages";
import type { RegularPageName, RegularPageUrls } from "./types";

export const languagesWithoutMagnitudePages: LanguageCode[] = ["ro-md"];

export const regularPages: Record<RegularPageName, RegularPageUrls> = {
  cookies: {
    fallback: "cookies",
    fi: "evasteet",
    nb: "informasjonskapsler",
  },
  airlineStrikeCompensation: {
    da: "strike/kompensation-for-flystrejke",
    de: "strike/entschaedigung-bei-streik-der-fluggesellschaft",
    el: "strike/αποζημίωση-σε-περίπτωση-απεργίας-αερ",
    en: "strike/airline-strike-compensation",
    es: "strike/compensacion-por-huelga-de-aerolinea",
    fi: "strike/korvaukset-lentolakoista",
    fr: "strike/indemnite-de-greve-des-compagnies-aeriennes",
    it: "strike/risarcimento-per-sciopero-della-compagnia-aerea",
    nb: "strike/kompensasjon-ved-flystreik",
    nl: "strike/compensatie-voor-staking-van-de-luchtvaartmaatschappij",
    pl: "strike/odszkodowanie-za-lot-zaklocony-wskutek-strajku-linii-lotniczej",
    "pt-br": "strike/indenizacao-greve-companhias-aereas",
    "pt-pt": "strike/compensacao-por-greve-da-companhia-aerea",
    ro: "strike/despagubiri-datorate-pentru-greva-la-compania-aeriana",
    ru: "strike/компенсация-в-случае-забастовки-рабо",
    sv: "strike/ersattning-for-flygstrejk",
    isMagnitude: true,
  },
  airlines: {
    da: "airlines",
    de: "airlines",
    el: "airlines",
    en: "airlines",
    es: "airlines",
    fi: "airlines",
    it: "airlines",
    fr: "airlines",
    nb: "airlines",
    nl: "airlines",
    pl: "airlines",
    pt: "airlines",
    ro: "airlines",
    ru: "airlines",
    sv: "airlines",
    isMagnitude: true,
  },

  airports: {
    da: "airports",
    de: "airports",
    el: "airports",
    en: "airports",
    es: "airports",
    fi: "airports",
    it: "airports",
    fr: "airports",
    nb: "airports",
    nl: "airports",
    pl: "airports",
    pt: "airports",
    ro: "airports",
    ru: "airports",
    sv: "airports",
    isMagnitude: true,
  },
  webapp: {
    isExternal: true,
    bg: `${config.webappUrl}?lang=bg`,
    cs: `${config.webappUrl}?lang=cs`,
    da: `${config.webappUrl}?lang=da`,
    de: `${config.webappUrl}?lang=de`,
    el: `${config.webappUrl}?lang=el`,
    en: `${config.webappUrl}?lang=en`,
    es: `${config.webappUrl}?lang=es`,
    fi: `${config.webappUrl}?lang=fi`,
    fr: `${config.webappUrl}?lang=fr`,
    hu: `${config.webappUrl}?lang=hu`,
    it: `${config.webappUrl}?lang=it`,
    nb: `${config.webappUrl}?lang=nb`,
    nl: `${config.webappUrl}?lang=nl`,
    pl: `${config.webappUrl}?lang=pl`,
    "pt-br": `${config.webappUrl}?lang=pt-BR`,
    "pt-pt": `${config.webappUrl}?lang=pt`,
    ro: `${config.webappUrl}?lang=ro`,
    ru: `${config.webappUrl}?lang=ru`,
    sv: `${config.webappUrl}?lang=sv`,
    "zh-cn": `${config.webappUrl}?lang=zh-CN`,
    tr: `${config.webappUrl}?lang=tr`,
    fallback: `${config.webappUrl}?lang=en`,
  },

  ahpBuyEssential: {
    isExternal: true,
    da: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=da`,
    de: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=de`,
    el: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=el`,
    en: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=en&optimizely=on`,
    es: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=es`,
    fi: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=fi`,
    fr: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=fr`,
    it: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=it`,
    nb: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=nb`,
    nl: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=nl`,
    pl: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=pl`,
    "pt-br": `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=pt-BR`,
    "pt-pt": `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=pt`,
    ro: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=ro`,
    ru: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=ru`,
    sv: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=sv`,
    "zh-cn": `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=zh-CN`,
    tr: `${config.ahplusUrl}/memberships/buy?channel=lp_essential&lang=tr`,
    fallback: `${config.ahplusUrl}/memberships/buy?channel=lp_essential`,
  },

  ahpBuyComplete: {
    isExternal: true,
    da: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=da`,
    de: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=de`,
    el: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=el`,
    en: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=en&optimizely=on`,
    es: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=es`,
    fi: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=fi`,
    fr: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=fr`,
    it: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=it`,
    nb: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=nb`,
    nl: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=nl`,
    pl: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=pl`,
    "pt-br": `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=pt-BR`,
    "pt-pt": `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=pt`,
    ro: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=ro`,
    ru: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=ru`,
    sv: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=sv`,
    "zh-cn": `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=zh-CN`,
    tr: `${config.ahplusUrl}/memberships/buy?channel=lp_complete&lang=tr`,
    fallback: `${config.ahplusUrl}/memberships/buy?channel=lp_complete`,
  },

  webappNewClaim: {
    isExternal: true,
    passLanguageToUrl: true,
    baseUrl: `${config.funnelUrl}/claims/new`,
    fallback: `${config.funnelUrl}/claims/new?lang=en`,
  },

  webappBarcodeScanner: {
    isExternal: true,
    passLanguageToUrl: true,
    baseUrl: `${config.funnelUrl}/claims/barcode/scanner`,
    fallback: `${config.funnelUrl}/claims/barcode/scanner?lang=en`,
  },

  webappBarcodeUploader: {
    isExternal: true,
    passLanguageToUrl: true,
    baseUrl: `${config.funnelUrl}/claims/barcode/uploader`,
    fallback: `${config.funnelUrl}/claims/barcode/uploader?lang=en`,
  },

  careers: {
    isExternal: true,
    fallback: "https://careers.airhelp.com/",
  },
};
